import { FC } from 'react';
import { Chip, Autocomplete as MuiAutocomplete, TextField } from '@mui/material';
import { ArrowDownIcon, CloseIcon } from '~/icons';
import { useTableFilters } from '../context';
import { FilterComponentProps, TableFilterOptionItem } from './types';

interface AutocompleteFilterProps extends FilterComponentProps {
  multiple?: boolean;
}

const AutocompleteFilter: FC<AutocompleteFilterProps> = ({ options, filterId, multiple = false }) => {
  const { selectedFilters: allSelectedFilters, changeFilters } = useTableFilters();
  const selectedFilters = allSelectedFilters[filterId];

  const commonProps = {
    options: options || [],
    clearIcon: <CloseIcon />,
    popupIcon: <ArrowDownIcon />,
    isOptionEqualToValue: (option: TableFilterOptionItem, value: TableFilterOptionItem) => option.id === value.id,
    renderInput: (params: object) => <TextField sx={{ wrap: 'flex-wrap' }} {...params} />,
  };

  if (multiple) {
    return (
      <MuiAutocomplete
        {...commonProps}
        multiple
        value={selectedFilters}
        onChange={(_event, newValues) => changeFilters(filterId, newValues as TableFilterOptionItem[])}
        renderValue={(value, getItemProps) =>
          (value as TableFilterOptionItem[]).map((option, index) => {
            const { key, ...itemProps } = getItemProps({ index });

            return (
              <Chip
                key={key ?? option.id}
                sx={{ fontSize: '10px' }}
                label={option.label}
                {...itemProps}
                deleteIcon={<CloseIcon />}
              />
            );
          })
        }
      />
    );
  }

  return (
    <MuiAutocomplete
      {...commonProps}
      value={selectedFilters[0] ?? null}
      onChange={(_event, newValue) => changeFilters(filterId, newValue ? [newValue as TableFilterOptionItem] : [])}
    />
  );
};

export default AutocompleteFilter;
